import React, { useState, useEffect } from 'react';

import './styles.css';

import eventServices from '../../../../services/academy/eventServices';
import classServices from '../../../../services/academy/classServices';

import compare from '../../../../functions/compare';

import Popup from '../../../../components/Popup';
import Input from '../../../../components/Input';
import { FaRegCalendarAlt } from 'react-icons/fa';

function PopupNewEvent(props) {
    const [tittle, setTittle] = useState('');
    const [description, setDescription] = useState('');
    const [date, setDate] = useState('01/01/2021');
    const [eventClass, setEventClass] = useState("Evento da academia");
    const [block, setBlock] = useState("Não");
    const [classes, setClasses] = useState([]);
    const [startTime, setStartTime] = useState('00:00');
    const [endTime, setEndTime] = useState('00:00');

    useEffect(() => {
        readClasses();
    }, []);

    useEffect(() => {
        if (props.visibility) {
            const dateNow = new Date();
            setDate(`${dateNow.getFullYear()}-${String(dateNow.getMonth() + 1).padStart(2, '0')}-${String(dateNow.getDate()).padStart(2, '0')}`);
            setStartTime(`${String(dateNow.getHours()).padStart(2, '0')}:00`);
            setEndTime(`${String((dateNow.getHours() + 2) % 24).padStart(2, '0')}:00`);
        }
    }, [props.visibility]);

    async function createEvent() {
        if (tittle && description && date && startTime && endTime && eventClass && block) {
            console.log(eventClass);
            const eventClassInfos = classes.find((item) => `${item.nome} - ${item.faixa_etaria}` === eventClass);
            const response = await eventServices.postEvent(tittle, description, startTime, endTime, date, eventClassInfos ? eventClassInfos.id : null, block === "Sim" ? true : false);
            if (response.status === 201) {
                setTittle('');
                setDescription('');
                setEventClass("Evento da academia");
                setBlock("Não");
                props.onCreate(response.data.data);
                props.setVisibility(false);
            } else {
                if(response.response && response.response.data && response.response.data.error) alert(response.response.data.error);
                else alert("Erro ao criar novo evento, tente novamente!");
            }
        } else
            alert("Preencha os dados obrigatórios*");
    }

    async function readClasses() {
        const response = await classServices.getClasses();
        if (response.status === 200) {
            setClasses(response.data.sort((a, b) => compare(a.nome, b.nome)));
        } else
            alert("Erro ao ler turmas, tente novamente!");
    }

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaRegCalendarAlt />}
            tittle='Novo evento'
        >
            <form>
                <Input
                    label='Título*'
                    placeholder="Insira um título"
                    id='calendar-new-event-tittle'
                    onChange={(event) => setTittle(event.target.value)}
                    value={tittle}
                />
                <Input
                    label='Descrição*'
                    placeholder="Insira uma descrição"
                    type='textarea'
                    id='calendar-new-event-description'
                    onChange={(event) => setDescription(event.target.value)}
                    value={description}
                />
                <Input
                    label="Data*"
                    type='date'
                    id='calendar-new-event-date'
                    onChange={(event) => setDate(event.target.value)}
                    value={date}
                />
                <div className='line'>
                    <Input
                        label='Início*'
                        type='time'
                        id='calendar-new-event-init-time'
                        onChange={(event) => setStartTime(event.target.value)}
                        value={startTime}
                    />
                    <Input
                        label='Fim*'
                        placeholder="Selecione a frequência"
                        type='time'
                        id='calendar-new-event-end-time'
                        onChange={(event) => setEndTime(event.target.value)}
                        value={endTime}
                    />
                </div>
                <div className='line'>
                    <Input
                        label='Turma'
                        type='select'
                        noFilterOptions
                        options={["Evento da academia", ...classes.map((item) => `${item.nome} - ${item.faixa_etaria}`)]}
                        id='calendar-new-event-type'
                        onChange={(event) => setEventClass(event.target.value)}
                        value={eventClass}
                    />
                    <Input
                        label='Bloquear horário?'
                        type='select'
                        noFilterOptions
                        options={["Não", "Sim"]}
                        id='calendar-new-event-type'
                        onChange={(event) => setBlock(event.target.value)}
                        value={block}
                    />
                </div>
                <button type='button' onClick={createEvent}>Adicionar evento</button>
            </form>
        </Popup>
    )
}

export default PopupNewEvent;